<template>
    <div class="h-100 d-flex flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_StructureStamp") }}</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>
        <div class="border-top p-4 flex-1 d-flex flex-column overflow-auto">
            <v-layout wrap>
                <div class="flex-1">
                    <div class="col-12 ">
                        <div class="d-flex justify-content-between align-items-center">
                            <v-file-input accept=".jpg,.jpeg,.png" v-model="files" multiple color="deep-purple accent-4"
                                counter label="Stamp" placeholder="Select your files" prepend-icon="mdi-paperclip" outlined
                                :show-size="1000" @change="onFileChanged">
                                <template v-slot:selection="{ index, text }">
                                    <v-chip v-if="index < 2" dark label small>
                                        {{ text }}
                                    </v-chip>
                                    <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                                        +{{ files.length - 2 }} File(s)
                                    </span>
                                </template>
                            </v-file-input>
                            <v-btn style="margin-left: 13px;height: 54px;margin-bottom: 15px;" color="primary"
                                @click="onFileSave">
                                Add
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <label>Stamp</label>
                    <div class="image-container">
                    <v-img  :src=stampData ></v-img>
                    </div>
                </div>
            </v-layout>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
export default {
    name: 'StructureStamp',
    components: { Multiselect },
    data() {
        return {
            files: [],
            stampData: "#",
            loading: false,
            utils: utils,
        };
    },
    props: {
        structure_id: Number,
    },
    methods:
    {
       
        createImage(file) {
            const reader = new FileReader();
            reader.onload = e => {
                this.stampData = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        onFileChanged(evt) {
            if (!evt[0].name.endsWith('.jpg')&&!evt[0].name.endsWith('.jpeg')&&!evt[0].name.endsWith('.png')) {
                     window.showAlert(this.$t("res_Msgs_ErrorTemplate"), "error") 
                     this.stampData =""
                     this.files=[]
                     return;
            } 
            if (this.files.length == 0) {
                return;
            }
            this.createImage(this.files[0]);
        },
        onFileSave(e) {
            if (this.files.length == 0) {
                window.showAlert("res_Msgs_PleaseSelectStamp", "warning");
            }
            else if (this.files[0].size <= 0 || this.files[0].size > parseInt(constants.maxAttachmentSizeInByte)) {
                window.showAlert(window.translate("res_Msgs_FileSizeValidation1") + constants.maxAttachmentSizeInMb +window.translate("res_Msgs_FileSizeValidation2"), "warning");
            }
            else {
                this.uploadFile(this.files[0]);
            }
        },
        uploadFile(selectedFiles) {
            let attachments = new FormData();
            attachments.append('structureId', this.structure_id)
            attachments.append('originalMail[0]', selectedFiles)
            const headers2 = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
            };
            axios.post(constants.baseApiUrl + 'Admin/UploadStamp', attachments, { headers: headers2 })
                .then(response => {
                    //;
                    if (response == undefined || response.data == null) {
                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                    } else {
                        window.showAlert('res_Msgs_StampUploaded', 'success');
                        this.files = [];
                        this.getStructureStamp()
                    }
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading())
        },
        getStructureStamp() {
            this.stampData = "";
            axios.get(constants.baseApiUrl + 'Admin/GetStructureStampByStructureId?structureId=' + this.structure_id)
                .then(response => {
                    if (response == undefined || response.data == null) {
                        this.stampData = "";
                    } else {
                        if (response.data != "" && response.data != null) {
                            this.stampData = "data:image/png;base64," + response?.data?.image
                        }
                    }
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading())
        },
        deleteStructureStamp() {
            axios.post(constants.baseApiUrl + 'Admin/DeleteStructureStampByStructureId?structureId=' + this.structure_id)
                .then(response => {
                    if (response == undefined || response.data == null) {
                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                    } else {
                        this.files = [];
                        this.getStructureStamp()
                    }
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading())
        }
    },
    watch:
    {
        structure_id: function (newVal, oldVal) {
            this.getStructureStamp();
        }
    },
    mounted() {
        this.getStructureStamp();
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
img#ItemPreview {
    width: 100px;
    margin: 0.5rem 0;

}
.image-container {
  max-width: 350px;
  max-height: 250px;
 
}
.v-image__image--cover {
    /* background-size: cover; */
    background-size: contain !important;
}
</style>